module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav",
    class: ['index' + _vm.pAIndex, {
      'layout-line': _vm.layout == 'line'
    }]
  }, [(!_vm.adjusts.length && !_vm.isBigMilk && !_vm.isIce) ? _c('li', {
    staticClass: "col-xs-12 p-x-0 order-item adjust text-no-adjust"
  }, [_c('div', [_vm._v("此商品不需調整配料/比例")])]) : _vm._e(), _vm._v(" "), (!_vm.adjusts.length && _vm.isBigMilk) ? _c('li', {
    staticClass: "col-xs-12 p-x-0 order-item adjust text-no-adjust"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.adjusts.length && _vm.isIce) ? _c('li', {
    staticClass: "col-xs-12 p-x-0 order-item adjust text-no-adjust"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.adjusts), function(adjust, aIndex) {
    return (adjust) ? _c('li', {
      key: _vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id],
      staticClass: "col-xs-12 p-x-0 order-item adjust",
      class: ['adjust-' + _vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id], 'adjust-' + _vm.currentProduct[_vm.schema.product.product_id]]
    }, [_c('h4', [_vm._v(_vm._s(adjust[_vm.schema.adjust.name]) + "選擇\n      "), (adjust[_vm.schema.adjust.max_limit] != 1 && adjust[_vm.schema.adjust.max_limit] != 0) ? _c('span', {
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(最多可選" + _vm._s(adjust[_vm.schema.adjust.max_limit]) + "項)")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "options",
      class: 'options-' + _vm.currentProduct[_vm.schema.product.product_id] + '-' + aIndex,
      staticStyle: {
        "margin-left": "-5px"
      }
    }, _vm._l((adjust[_vm.schema.adjust.option_list]), function(option, oIndex) {
      return _c('div', {
        key: _vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id] + '-' + option[_vm.schema.option.product_id],
        staticClass: "btn btn-default btn-option",
        class: [{
            disabled: adjust[_vm.schema.adjust.is_enable] == 0
          },
          'option-' + _vm.currentProduct[_vm.schema.product.product_id] + '-index' + _vm.pAIndex,
          {
            'btn-option--active': _vm.isActive(_vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id] + '-' + option[_vm.schema.option.product_id])
          }
        ],
        attrs: {
          "id": 'option-' + _vm.currentProduct[_vm.schema.product.product_id] + '-' + option[_vm.schema.option.product_id],
          "optionA": 'adjust-' + adjust[_vm.schema.adjust.product_id]
        },
        on: {
          "click": function($event) {
            return _vm.clickOption(option, oIndex, adjust, aIndex)
          }
        }
      }, [_c('div', {
        staticClass: "option-name"
      }, [_vm._v("\n          " + _vm._s(option[_vm.schema.option.name]) + "\n        ")]), _vm._v(" "), (Array.isArray(option) && Array.isArray(adjust) && _vm.optionPrice(option, adjust)) ? _c('div', {
        staticClass: "option-price"
      }, [_vm._v("\n          " + _vm._s(_vm.optionPrice(option, adjust)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.optionNumList[0][option[_vm.schema.option.product_id]] && _vm.optionNumList[0][option[_vm.schema.option.product_id]] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n          " + _vm._s(_vm.optionNumList[0][option[_vm.schema.option.product_id]]) + "\n        ")]) : (_vm.optionNumList[0][option[_vm.schema.option.product_id]] && _vm.optionNumList[0][option[_vm.schema.option.product_id]] === 1 && option[_vm.schema.option.max_limit] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n          " + _vm._s(_vm.optionNumList[0][option[_vm.schema.product.product_id]]) + "\n        ")]) : _vm._e()])
    }), 0)]) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n      嚴選乳源、成分無調整"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-red text-14"
  }, [_vm._v("★ 此商品不列入外送金額，尚請見諒")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-red text-14"
  }, [_vm._v("★ 為保持鮮奶品質，外送建議一公里內")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n      成分無調整"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-red text-14"
  }, [_vm._v("★ 此商品為冰萃/冰沙口感，現場選購口感較佳，不建議外送時選購")]), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-338f69d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/MenuOptions.vue
// module id = 2379
// module chunks = 1